module.exports = __webpack_public_path__ + "static/media/deliverybg.8e60bfad.png";